<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,11C8,11,7,11,7,11C7,11,7,12,7,12C7,12,8,12,8,12C8,12,8,11,8,11C8,11,8,11,8,11C8,11,8,11,8,11ZM4,11C4,11,3,11,3,11C3,11,3,12,3,12C3,12,4,12,4,12C4,12,4,11,4,11C4,11,4,11,4,11C4,11,4,11,4,11ZM11,3C11.6,3,12,2.5,12,2C12,2,12,1,12,1C12,0.5,11.6,0,11,0C10.4,0,10,0.5,10,1C10,1,10,2,10,2C10,2.5,10.5,3,11,3C11,3,11,3,11,3C11,3,11,3,11,3ZM4,3C4.5,3,5,2.5,5,2C5,2,5,1,5,1C5,0.5,4.5,0,4,0C3.5,0,3,0.5,3,1C3,1,3,2,3,2C3,2.5,3.5,3,4,3C4,3,4,3,4,3C4,3,4,3,4,3ZM14,1C14,1,13,1,13,1C13,1,13,2,13,2C13,3.1,12.1,4,11,4C9.9,4,9,3.1,9,2C9,2,9,1,9,1C9,1,6,1,6,1C6,1,6,2,6,2C6,3.1,5.1,4,4,4C2.9,4,2,3.1,2,2C2,2,2,1,2,1C2,1,1,1,1,1C0.5,1,0,1.5,0,2C0,2,0,14,0,14C0,14.5,0.5,15,1,15C1,15,14,15,14,15C14.6,15,15,14.5,15,14C15,14,15,2,15,2C15,1.5,14.6,1,14,1C14,1,14,1,14,1C14,1,14,1,14,1ZM5,13C5,13,2,13,2,13C2,13,2,10,2,10C2,10,5,10,5,10C5,10,5,13,5,13C5,13,5,13,5,13C5,13,5,13,5,13ZM5,9C5,9,2,9,2,9C2,9,2,6,2,6C2,6,5,6,5,6C5,6,5,9,5,9C5,9,5,9,5,9C5,9,5,9,5,9ZM9,13C9,13,6,13,6,13C6,13,6,10,6,10C6,10,9,10,9,10C9,10,9,13,9,13C9,13,9,13,9,13C9,13,9,13,9,13ZM9,9C9,9,6,9,6,9C6,9,6,6,6,6C6,6,9,6,9,6C9,6,9,9,9,9C9,9,9,9,9,9C9,9,9,9,9,9ZM13,13C13,13,10,13,10,13C10,13,10,10,10,10C10,10,13,10,13,10C13,10,13,13,13,13C13,13,13,13,13,13C13,13,13,13,13,13ZM13,9C13,9,10,9,10,9C10,9,10,6,10,6C10,6,13,6,13,6C13,6,13,9,13,9C13,9,13,9,13,9C13,9,13,9,13,9ZM12,7C12,7,11,7,11,7C11,7,11,8,11,8C11,8,12,8,12,8C12,8,12,7,12,7C12,7,12,7,12,7C12,7,12,7,12,7Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'TimelineEvents',
} as DefineComponent
</script>
